import React from 'react';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const lineClasses = cva(
  'block',
  {
    variants: {
      orientation: {
        horizontal: 'w-full',
        vertical: 'h-full',
      },
      variant: {
        solid: '',
        dashed: 'border-dashed',
        dotted: 'border-dotted',
      },
    },
    defaultVariants: {
      orientation: 'horizontal',
      variant: 'solid',
    },
  }
);

const Line = ({
  // Props for line configuration
  width,
  height,
  orientation = 'horizontal',
  variant = 'solid',
  color = '#e5e7eb',
  thickness = '1px',
  className,
  style,
  ...props
}) => {
  // Determine orientation based on width and height if provided
  let actualOrientation = orientation;
  if (width && height) {
    const widthNum = parseInt(width);
    const heightNum = parseInt(height);
    actualOrientation = widthNum > heightNum ? 'horizontal' : 'vertical';
  }

  // Build inline styles
  const lineStyles = {
    backgroundColor: variant === 'solid' ? color : 'transparent',
    borderColor: variant !== 'solid' ? color : undefined,
    width: actualOrientation === 'horizontal' ? (width || '100%') : thickness,
    height: actualOrientation === 'vertical' ? (height || '100%') : thickness,
    borderWidth: variant !== 'solid' ? thickness : undefined,
    ...style,
  };

  return (
    <div
      className={twMerge(
        lineClasses({ orientation: actualOrientation, variant }),
        className
      )}
      style={lineStyles}
      role="separator"
      aria-orientation={actualOrientation}
      {...props}
    />
  );
};

export default Line;